import { useLocalizedStrings } from "../LocalizationProvider";
export const useFilterOperators = () => {
    const L = useLocalizedStrings();
    const LOGIC_OPTIONS = [
        { value: 'And', label: L.component_library.filter_panel.and },
        { value: 'Or', label: L.component_library.filter_panel.or },
    ];
    const FILTER_OPERATOR_LABELS = {
        'equals': L.component_library.filter_panel.is,
        'not_equals': L.component_library.filter_panel.is_not,
        'contains': L.component_library.filter_panel.contains,
        'not_contains': L.component_library.filter_panel.does_not_contain,
        'empty': L.component_library.filter_panel.is_empty,
        'not_empty': L.component_library.filter_panel.is_not_empty,
        'greater_than': L.component_library.filter_panel.is_greater_than,
        'less_than': L.component_library.filter_panel.is_less_than,
        'after': L.component_library.filter_panel.is_after,
        'before': L.component_library.filter_panel.is_before,
        'exists': L.component_library.filter_panel.exists,
        'not_exists': L.component_library.filter_panel.not_exists
    };
    const OPERATORS_BY_TYPE = {
        text: [
            { value: 'equals', label: FILTER_OPERATOR_LABELS['equals'], requiresValue: true },
            { value: 'not_equals', label: FILTER_OPERATOR_LABELS['not_equals'], requiresValue: true },
            { value: 'contains', label: FILTER_OPERATOR_LABELS['contains'], requiresValue: true },
            { value: 'not_contains', label: FILTER_OPERATOR_LABELS['not_contains'], requiresValue: true },
            { value: 'empty', label: FILTER_OPERATOR_LABELS['empty'], requiresValue: false },
            { value: 'not_empty', label: FILTER_OPERATOR_LABELS['not_empty'], requiresValue: false },
            { value: 'exists', label: FILTER_OPERATOR_LABELS['exists'], requiresValue: false },
            { value: 'not_exists', label: FILTER_OPERATOR_LABELS['not_exists'], requiresValue: false },
        ],
        number: [
            { value: 'equals', label: FILTER_OPERATOR_LABELS['equals'], requiresValue: true },
            { value: 'not_equals', label: FILTER_OPERATOR_LABELS['not_equals'], requiresValue: true },
            { value: 'greater_than', label: FILTER_OPERATOR_LABELS['greater_than'], requiresValue: true },
            { value: 'less_than', label: FILTER_OPERATOR_LABELS['less_than'], requiresValue: true },
            { value: 'empty', label: FILTER_OPERATOR_LABELS['empty'], requiresValue: false },
            { value: 'not_empty', label: FILTER_OPERATOR_LABELS['not_empty'], requiresValue: false },
            { value: 'exists', label: FILTER_OPERATOR_LABELS['exists'], requiresValue: false },
            { value: 'not_exists', label: FILTER_OPERATOR_LABELS['not_exists'], requiresValue: false },
        ],
        date: [
            { value: 'equals', label: FILTER_OPERATOR_LABELS['equals'], requiresValue: true },
            { value: 'not_equals', label: FILTER_OPERATOR_LABELS['not_equals'], requiresValue: true },
            { value: 'after', label: FILTER_OPERATOR_LABELS['after'], requiresValue: true },
            { value: 'before', label: FILTER_OPERATOR_LABELS['before'], requiresValue: true },
            { value: 'empty', label: FILTER_OPERATOR_LABELS['empty'], requiresValue: false },
            { value: 'not_empty', label: FILTER_OPERATOR_LABELS['not_empty'], requiresValue: false },
            { value: 'exists', label: FILTER_OPERATOR_LABELS['exists'], requiresValue: false },
            { value: 'not_exists', label: FILTER_OPERATOR_LABELS['not_exists'], requiresValue: false },
        ],
        boolean: [
            { value: 'equals', label: FILTER_OPERATOR_LABELS['equals'], requiresValue: true },
            { value: 'not_equals', label: FILTER_OPERATOR_LABELS['not_equals'], requiresValue: true },
            { value: 'exists', label: FILTER_OPERATOR_LABELS['exists'], requiresValue: false },
            { value: 'not_exists', label: FILTER_OPERATOR_LABELS['not_exists'], requiresValue: false },
        ],
    };
    return {
        LOGIC_OPTIONS,
        FILTER_OPERATOR_LABELS,
        OPERATORS_BY_TYPE
    };
};
